import { useFirestore, useUser } from "reactfire";
import { addDoc, collection, setDoc } from "firebase/firestore";
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea, useDisclosure } from "@nextui-org/react";
import { createJob } from "../../services/jobservice";

export const NewKnowledgeBase = () => {
    const firestore = useFirestore();
    const user = useUser();

    const saveKbase = async (event: any) => {
        event?.preventDefault();
        const kbaseCollection = collection(firestore, 'kbases');

        const formData = new FormData(event.target);

        const data = {
            name: formData.get('name'),
            description: formData.get('description'),
            createdByName: user?.data?.displayName,
            createdBy: user?.data?.uid,
            lastUpdated: new Date().toISOString()
        }
        const kbase = await addDoc(kbaseCollection, data);
        const jobData = {
            createdBy: user?.data?.uid,
            type: "kbase",
            targetId: kbase.id,
            name: formData.get('name'),
            kbaseId: kbase.id,
            createdByName: user?.data?.displayName,
        }
        const jobId = await createJob(firestore, jobData);
        setDoc(kbase, { jobId: jobId }, { merge: true });
    }

    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    return (
        <>
            <Button color="primary" onPress={onOpen}>Create Knowledge Base</Button>
            <Modal
                isOpen={isOpen}
                onOpenChange={onOpenChange}
                placement="top-center"
            >
                <form onSubmit={saveKbase}>

                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">New Knowledge Base</ModalHeader>
                                <ModalBody>
                                    <Input
                                        autoFocus
                                        isRequired
                                        label="Name"
                                        name="name"
                                        placeholder="Provide a Name"
                                        variant="bordered"
                                    />
                                    <Textarea
                                        name="description"
                                        label="Description"
                                        placeholder="Describe your content"
                                        type="textarea"
                                        variant="bordered"
                                    />
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="flat" onPress={onClose}>
                                        Close
                                    </Button>
                                    <Button color="primary" onClick={onClose} type="submit">
                                        Save
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </form>
            </Modal>
        </>
    )
}